<template>
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 216 216" fill="currentColor">
  <path d="M198.34 40.65H17.66a4 4 0 00-4 4v126.7a4 4 0 004 4h180.68a4 4 0 004-4V44.65a4 4 0 00-4-4zm-176.68 8h81.92v118.7H21.66zm172.68 118.7h-81.92V48.65h81.92z"/>
  <rect width="5.99" height="18.4" x="121.97" y="96.64" rx="2.99"/>
  <rect width="5.99" height="18.4" x="87.86" y="96.64" rx="2.99"/>
</svg>
</template>